/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TextInput/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TextInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/TextInput",
  onChange
  
}) {
let questionAnswerValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'answer',
format: fromHelpers.sanitise,
})
let questionAnswerChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer',
})
let questionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isValid',
})
let questionAnswerValueData1 = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer',
})
let aggregateData = fromHelpers.markAsInvalid(questionIsValidValueData, questionAnswerValueData1)
let questionTextTransformValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'textTransform',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let questionAutoFocusValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'autoFocus',
})
let questionOrderValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'order',
})
let aggregateData1 = fromHelpers.shouldAutoFocus(questionAutoFocusValueData, questionOrderValueData)
let questionValidationValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'validation',
})
let constantData = 'email'
let aggregateData2 = fromAggregate.equals(questionValidationValueData, constantData)
let onKeyUp = fromHelpers.useOnKeyUp({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 marginTop={0}
 width={250}
 flexGrow={0}
 data="question.answer"
 format="helpers.js sanitise"
 value={questionAnswerValueData}
 onChange={questionAnswerChangeData}
 data="question.isValid"
 data="question.answer"
 aggregate="helpers.js markAsInvalid"
 invalid={!aggregateData}
 data="question.textTransform"
 textTransform={questionTextTransformValueData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXxs}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 onKeyUp={onKeyUp}
 data="question.autoFocus"
 data="question.order"
 aggregate="helpers.js shouldAutoFocus"
 autoFocus={aggregateData1}
 placeholder={aggregateData2 ? "you@example.com" : "start typing..."}
 data="question.validation"
 data="'email'"
 aggregate="/Data/aggregate.js equals"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}